// extracted by mini-css-extract-plugin
module.exports = {"expiredNotification":"styles_expiredNotification__1XZFG"};